module.exports = {"missingPermission":"Siamo spiacenti, al momento non hai accesso a questa pagina.","contactAdministration":"Contatta la persona nella tua azienda che amministra questo account di Trustpilot."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MissingPermission/localization/it-IT/strings.json
// module id = 1230
// module chunks = 0